import "./ItemSwitcher.scss";

import React, { memo } from "react";

import { ChevronIconRight } from "../icons/ChevronIconRight";
export interface IItemSwitcherProps {
  currentItem: number;
  itemsCount: number;
  onChange: (item: number) => void;
  isLooped?: boolean;
  disabled?: boolean;
}

const ItemSwitcher: React.FC<IItemSwitcherProps> = memo(
  ({ currentItem, itemsCount, onChange, isLooped, disabled }) => {
    const handlePrevious = () => {
      onChange(-1);
    };
    const handleNext = () => {
      onChange(+1);
    };

    return (
      <div className={`item-switcher ${disabled ? "disabled" : ""}`}>
        <button
          type="button"
          className="btn btn-icon"
          onClick={handlePrevious}
          disabled={(!isLooped && currentItem - 1 === 0) || disabled}
        >
          <span className="item-switcher-arrow left">
            <ChevronIconRight />
          </span>
          Previous
        </button>
        <span className="count-container">
          {currentItem} / {itemsCount}
        </span>
        <button
          type="button"
          className="btn btn-icon"
          onClick={handleNext}
          disabled={(!isLooped && currentItem === itemsCount) || disabled}
        >
          Next
          <span className="item-switcher-arrow">
            <ChevronIconRight />
          </span>
        </button>
      </div>
    );
  },
);

export { ItemSwitcher };
